

export const lightTheme ={
    body:"#FCF6F4",
    text:"#6E777C",
    fontFamily:"'Source Sans Pro', sans-serif",
    bodyRgba : "252, 246, 244",
    textRgba:"0,0,0",
}
export const darkTheme ={
    body:"#6E777C",
    text:"#FCF6F4",
    fontFamily:"'Source Sans Pro', sans-serif",
    textRgba : "252, 246, 244",
    bodyRgba : "0,0,0",
}